<template>
  <el-select v-model="contype" @change="getCty"  filterable  clearable placeholder="请选择柜型" size="small">
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.name"
      :value="item.name"
    ></el-option>
  </el-select>
</template>

<script>
import httpApi from "../../http/api";
export default {
  name: "contype",
  props: {
    contypes: { String }
  },
  data() {
    return {
      options: [], 
      contype: this.contypes
    };
  },
  methods: {
    getCty(e) {
      this.$emit("getCty", e);
    },
    init(){
      let that=this
      httpApi
      .listParams( {params:{
        type:"sys_container_type",
        enable:"1"
      }})
      .then(res => {
        if (res.data.code == "ok") {
          that.options = res.data.data;
        }
      });
    }
  },
  created() {
    this.init()
  },
  watch: {
    contypes: function(newVal) {
      this.contype = newVal;
    }
  }
};
</script>

<style>
</style>